export const svSwedish = {
  "Pensil Keyword": "Swedish",
  "Home": "Hem",
  "Explore Groups": "Utforska grupper",
  "Events": "Händelser",
  "Groups": "Grupper",
  "Links": "Länkar",
  "Direct Message": "Direktmeddelande",
  "Powered by": "Drivs av",
  "No groups here, please use + to create a new one, or join one see them here.": "Inga grupper här, använd + för att skapa en ny, eller gå med i en se dem här.",
  "Please join a group to see them here": "Gå med i en grupp för att se dem här",
  "Section can only be reordered within the group!": "Sektion kan endast ombeställas inom gruppen!",
  "Group Page": "Gruppsida",
  "Invite Members": "Bjud in medlemmar",
  "Join": "Ansluta sig till",
  "Joined": "Anslöt sig",
  "Create new section": "Skapa nytt avsnitt",
  "Group Setting drop down": "Gruppinställning rullgardinsmeny",
  "Share": "Dela",
  "Edit group": "Redigera grupp",
  "Delete group": "Ta bort grupp",
  "Leave": "Lämna",
  "Are you sure you want to delete the group?": "Är du säker på att du vill ta bort gruppen?",
  "Cancel": "Avboka",
  "Yes, Go Ahead": "Ja, varsågod",
  "Share via link": "Dela via länk",
  "Copy": "Kopiera",
  "Copied": "Kopierade",
  "Share on social media": "Dela på sociala medier",
  "Add Section": "Lägg till avsnitt",
  "Section Header": "Sektionshuvud",
  "Live": "Bo",
  "Create Post": "Skapa inlägg",
  "Notificaiton Bell": "Anmälan Bell",
  "All posts": "Alla inlägg",
  "Admin posts only": "Endast administratörsinlägg",
  "None": "Ingen",
  "Section Setting drop down": "Sektionsinställningar rullgardinsmeny",
  "Edit Section": "Redigera avsnitt",
  "Embed Section": "Bädda in avsnitt",
  "Delete Section": "Ta bort avsnitt",
  "Are you sure you want to delete the section?": "Är du säker på att du vill ta bort avsnittet?",
  "Section deleted!": "Avsnitt raderat!",
  "Create Group Pop up / Update": "Skapa grupp popup/uppdatering",
  "Create group": "Skapa grupp",
  "Basic Detail": "Grundläggande detalj",
  "Settings": "Inställningar",
  "Size 16:9 or 1600 by 900": "Storlek 16:9 eller 1600 x 900",
  "Group name": "Gruppnamn",
  "Enter group name": "Ange gruppnamn",
  "Suggestions: Spaces, Channels, Groups, Blog, Knowledgebase, etc": "Förslag: Utrymmen, kanaler, grupper, blogg, kunskapsbas, etc",
  "Group Description": "Gruppbeskrivning",
  "Enter description here": "Ange beskrivning här",
  "Group Type": "Grupptyp",
  "Open": "Öppna",
  "Visible to all & anyone can join": "Synlig för alla och alla kan vara med",
  "Closed": "Stängd",
  "User will have to request to join the group": "Användaren måste begära att få gå med i gruppen",
  "Paid": "Betalt",
  "Group Price": "Grupppris",
  "Currency (Default: INR)": "Valuta (standard: INR)",
  "User will have to pay to join the group": "Användaren måste betala för att gå med i gruppen",
  "Make this a private group": "Gör detta till en privat grupp",
  "Private group will only be visible to members who are part of it. Admin can add members manually from member list": "Privat grupp kommer endast att vara synlig för medlemmar som är en del av den. Admin kan lägga till medlemmar manuellt från medlemslistan",
  "Upload from device": "Ladda upp från enheten",
  "Search image": "Sök bild",
  "Valid group name required!": "Giltigt gruppnamn krävs!",
  "Update Group": "Uppdatera grupp",
  "SEO Settings": "SEO-inställningar",
  "Custom URL": "Anpassad webbadress",
  "Meta Title": "Meta titel",
  "Maximum length of 255 characters allowed": "Maximal längd på 255 tecken tillåts",
  "Meta Description": "Metabeskrivning",
  "Open Graph Detail": "Öppna grafdetalj",
  "Open Graph Title": "Öppna Graftitel",
  "Open Graph Description": "Öppna grafbeskrivning",
  "Open Graph Image": "Öppna Graph Image",
  "Recommended dimensions: 1200px by 630px with a 1.91:1 aspect ratio.": "Rekommenderade mått: 1200 x 630 px med ett bildförhållande på 1,91:1.",
  "If no URL is used, it will automatically picked your group thumbnail.": "Om ingen URL används kommer den automatiskt att välja din gruppminiatyrbild.",
  "Create Section Pop up / Update": "Skapa avsnitt Pop up / Uppdatera",
  "Create Section": "Skapa sektion",
  "Section Name": "Sektionens namn",
  "Suggestions: General, Introductions, Community Guidelines": "Förslag: Allmänt, Introduktioner, Community Riktlinjer",
  "Section Type": "Sektionstyp",
  "Post Type": "Typ av inlägg",
  "Group Chat": "Gruppchatt",
  "Who can post in this section?": "Vem kan skriva i det här avsnittet?",
  "Only Admin": "Endast admin",
  "Any user": "Vilken användare som helst",
  "Sorting order for section": "Sorteringsordning för avsnitt",
  "Latest first": "Senaste först",
  "Oldest post first": "Äldsta inlägget först",
  "Section Appearance": "Sektionens utseende",
  "List View": "Listvy",
  "Grid View": "Rutnätsvy",
  "Make this closed section": "Gör denna stängda sektion",
  "Members will have to request access to see section content": "Medlemmar måste begära åtkomst för att se avsnittets innehåll",
  "Make this a private section": "Gör detta till ett privat avsnitt",
  "Disables requests (Make sure closed section is selected as well).": "Inaktiverar förfrågningar (Se till att stängt avsnitt också är valt).",
  "Post Editor": "Inläggsredaktör",
  "Create new post in": "Skapa ett nytt inlägg i",
  "Add Cover Picture": "Lägg till omslagsbild",
  "Heading (Optional)": "Rubrik (valfritt)",
  "Write here..": "Skriv här..",
  "Picture": "Bild",
  "Video": "Video",
  "Attachment": "Fastsättning",
  "Poll": "Röstning",
  "Embed Code": "Bädda in kod",
  "Tags": "Taggar",
  "Toggle to question": "Växla till fråga",
  "Poll expire time": "Omröstningens utgångstid",
  "Poll question": "Omröstningsfråga",
  "Enter Question": "Skriv in fråga",
  "Question": "Fråga",
  "Option": "Alternativ",
  "Options": "Alternativ",
  "Add Option": "Lägg till alternativ",
  "Poll Expiry time": "Omröstningens utgångstid",
  "12 Hours": "12 timmar",
  "1 Day": "1 dag",
  "2 Days": "2 dagar",
  "1 Week": "1 vecka",
  "2 Weeks": "2 veckor",
  "Always Open": "Alltid öppet",
  "Write embeddable code": "Skriv inbäddningsbar kod",
  "Click here to add embed code.": "Klicka här för att lägga till inbäddningskod.",
  "Paste your embed code here!": "Klistra in din inbäddningskod här!",
  "Post Settings": "Inläggsinställningar",
  "Update Post": "Uppdatera inlägg",
  "Update": "Uppdatera",
  "Start meeting / Video call / Live": "Starta möte / Videosamtal / Live",
  "Meeting Name": "Mötesnamn",
  "Suggestion: Group discussion etc": "Förslag: Gruppdiskussion mm",
  "Description": "Beskrivning",
  "Enter description here (optional)": "Ange beskrivning här (valfritt)",
  "When do you want to start the session": "När vill du starta sessionen",
  "Right now": "Just nu",
  "Schedule for later": "Schemalägg för senare",
  "Group video call": "Gruppvideosamtal",
  "Webinar": "Webinarium",
  "Go Live": "Gå live",
  "Info on the Post": "Info på Posten",
  "Post comment": "Skriv kommentar",
  "Comment": "Kommentar",
  "Comments": "Kommentarer",
  "Reply": "Svar",
  "Replies": "Svar",
  "Share via URL": "Dela via URL",
  "Reshare in other sections": "Dela vidare i andra avsnitt",
  "Post Card Drop Down": "Vykort Drop Down",
  "Bookmark": "Bokmärke",
  "Pin post": "Fäst inlägg",
  "Edit": "Redigera",
  "Embed Post": "Bädda in inlägg",
  "Delete": "Radera",
  "Remove Pin": "Ta bort stift",
  "Remove Bookmark": "Ta bort bokmärke",
  "Just copy paste this code wherever you want it to be embedded": "Bara kopiera och klistra in den här koden där du vill att den ska bäddas in",
  "Height": "Höjd",
  "Preview": "Förhandsvisning",
  "Copied to clipboard": "Kopierade till urklipp",
  "Select Widgets": "Välj Widgets",
  "Add widgets to": "Lägg till widgets till",
  "You can change their order by dragging & dropping the widgets over each other": "Du kan ändra deras ordning genom att dra och släppa widgetarna över varandra",
  "Please note: Widget wont be displayed if there is no data available,": "Observera: Widget kommer inte att visas om det inte finns någon tillgänglig data,",
  "Group Members": "Gruppmedlemmar",
  "Group Leaderboard": "Grupptavlan",
  "Community Leaderboard": "Community Leaderboard",
  "Trending Posts": "Populära inlägg",
  "Group Events": "Grupphändelser",
  "Add Custom": "Lägg till anpassad",
  "Save Widgets": "Spara widgets",
  "Visible to user": "Synlig för användaren",
  "Visible to admin": "Synlig för admin",
  "Add widget to": "Lägg till widget till",
  "Upload cover picture": "Ladda upp omslagsbild",
  "1:1 aspect ration (recommended)": "Bildförhållande 1:1 (rekommenderas)",
  "Card Title": "Korttitel",
  "Enter widget name": "Ange widgetnamn",
  "Small Description (try to keep it under 50 words)": "Liten beskrivning (försök att hålla den under 50 ord)",
  "Enter description": "Ange beskrivning",
  "Button Title": "Knappens titel",
  "Enter button name": "Ange knappens namn",
  "Siggestion: Know more, Join, Apply, etc": "Siggestion: Lär dig mer, gå med, ansök osv",
  "URL link": "URL-länk",
  "Create custom widget": "Skapa anpassad widget",
  "Custom widget created successfully": "Anpassad widget har skapats",
  "Widgets": "Widgets",
  "Members": "Medlemmar",
  "See All": "Se alla",
  "Communtiy Top Contributors": "Community Top Contributors",
  "Community Members": "Gemenskapens medlemmar",
  "Group Top Contributors": "Gruppens bästa bidragsgivare",
  "Upcoming Events": "Kommande evenemang",
  "Home Page Banner": "Hemsida banner",
  "Edit Banner": "Redigera banner",
  "Home page Edit Banner Pop up": "Hemsida Redigera banner Pop up",
  "Update Banner": "Uppdatera banner",
  "Search": "Söka",
  "Upload Image": "Ladda upp bild",
  "Remove": "Ta bort",
  "Banner image (please use 16:6 ratio or 1600px by 600px image for the best view)": "Bannerbild (vänligen använd 16:6-förhållandet eller 1600px x 600px bild för bästa visning)",
  "Banner Title": "Bannertitel",
  "Enter here": "Gå in här",
  "Suggestion: Welcome to my community etc": "Förslag: Välkommen till min community osv",
  "Banner Description": "Bannerbeskrivning",
  "Enter banner description": "Ange bannerbeskrivning",
  "Save Banner Info": "Spara bannerinformation",
  "Home Page Feed": "Hemsidans flöde",
  "Recent": "Ny",
  "Top Posts": "Toppinlägg",
  "Trending": "Trendigt",
  "Home Feed Groups": "Hemflödesgrupper",
  "": "#VALUE!",
  "My Profile": "Min profil",
  "Logout": "Utloggning",
  "Notification": "Underrättelse",
  "Notifications": "Aviseringar",
  "Mark all viewed": "Markera alla visade",
  "has created a post": "har skapat ett inlägg",
  "wants to join": "vill vara med",
  "has commented on your post": "har kommenterat ditt inlägg",
  "has replied to your comment": "har svarat på din kommentar",
  "Search for tags": "Sök efter taggar",
  "All groups": "Alla grupper",
  "Search result": "Sökresultat",
  "No post found for selected hashtag": "Inget inlägg hittades för den valda hashtaggen",
  "Start a conversation": "Starta en konversation",
  "Search by name": "Sök på namn",
  "Upcoming": "Kommande",
  "UPCOMING": "KOMMANDE",
  "Past": "Förbi",
  "PAST": "FÖRBI",
  "No upcoming events": "Inga kommande evenemang",
  "Create event popup": "Skapa event-popup",
  "Event details": "Händelsedetaljer",
  "16:9 aspect ratio": "16:9 bildförhållande",
  "Event name": "Händelsenamn",
  "Enter event name": "Ange händelsenamn",
  "Host Name": "Värdnamn",
  "You will be made host if none selected": "Du kommer att bli värd om ingen väljs",
  "Write here...": "Skriv här...",
  "No. of registration for the event": "Antal anmälningar till evenemanget",
  "Unlimited": "Obegränsat",
  "When & where": "När & var",
  "From": "Från",
  "Start date": "Startdatum",
  "time": "tid",
  "To": "Till",
  "End date": "Slutdatum",
  "Current time zone:": "Aktuell tidszon:",
  "Can be updated from the communtiy setting": "Kan uppdateras från gemenskapsinställningen",
  "Online event": "Onlineevenemang",
  "Add meeting link": "Lägg till möteslänk",
  "Meeting link will be generated once event is created": "Möteslänk kommer att genereras när händelsen har skapats",
  "Venue": "Mötesplats",
  "Enter address": "Ange adress",
  "Create": "Skapa",
  "Invite": "Bjuda",
  "Share event via link": "Dela event via länk",
  "Copy__1": "Kopiera",
  "Select section to post this event": "Välj avsnitt för att lägga upp denna händelse",
  "Once posted, members of that group or section will recieve an notification": "När de har postats kommer medlemmar i den gruppen eller sektionen att få ett meddelande",
  "Post": "Posta",
  "RSVP": "OSA",
  "Book Event": "Boka event",
  "Yes, I'll attend": "Ja, jag ska vara med",
  "May be": "Kan vara",
  "No, I won't attend": "Nej, jag kommer inte att vara med",
  "Date & Time": "Datum och tid",
  "Host": "Värd",
  "Online meeting": "Onlinemöte",
  "Meeting link will be visible once registered for the event": "Möteslänken kommer att synas när du har registrerat dig för evenemanget",
  "User Management": "Användarhantering",
  "Go bac to community": "Gå tillbaka till gemenskapen",
  "Manage Members": "Hantera medlemmar",
  "Member": "Medlem",
  "Invited": "Inbjudna",
  "Search for member": "Sök medlem",
  "Add to group": "Lägg till i grupp",
  "Send Direct Message": "Skicka direktmeddelande",
  "Change role": "Byt roll",
  "Kick from community": "Kick från gemenskapen",
  "Super Admin": "Super Admin",
  "Super admin will have full access to the communtiy settings": "Superadmin kommer att ha full åtkomst till gemenskapsinställningarna",
  "Group Admin": "Gruppadministratör",
  "Admin of the selected group can edit the group information and create, edt or delete section under selected group": "Administratör för den valda gruppen kan redigera gruppinformationen och skapa, redigera eller ta bort avsnitt under vald grupp",
  "Group Moderator": "Gruppmoderator",
  "Group moderator can create or delete post, comment, reply & messages in the selected group.": "Gruppmoderator kan skapa eller ta bort inlägg, kommentera, svara och meddelanden i den valda gruppen.",
  "User": "Användare",
  "Save": "Spara",
  "User role updated successfully": "Användarrollen har uppdaterats",
  "Leaderboard": "Leaderboard",
  "Click on the column header for sorting": "Klicka på kolumnrubriken för sortering",
  "Rank": "Rang",
  "Karma Points": "Karma poäng",
  "Custom Points": "Anpassade poäng",
  "Follow": "Följa",
  "Upvotes": "Uppröster",
  "Posts": "Inlägg",
  "Add custom points": "Lägg till anpassade poäng",
  "Subtract custom points": "Subtrahera anpassade poäng",
  "Enter no. of points": "Ange nr. poäng",
  "Add points": "Lägg till poäng",
  "Invite members to": "Bjud in medlemmar till",
  "Invite via link": "Bjud in via länk",
  "Invite via email": "Bjud in via e-post",
  "Add more": "Lägg till fler",
  "Upload a CSV": "Ladda upp en CSV",
  "Please upload a comma-seprated CSV file, with header as name, email.": "Ladda upp en kommaseparerad CSV-fil, med rubrik som namn, e-post.",
  "Here is a template CSV file": "Här är en CSV-mall",
  "Upload File": "Ladda upp fil",
  "Send Invite": "Skicka inbjudan",
  "Mail Template": "Mail mall",
  "Send Test Mail": "Skicka testmail",
  "Hey": "Hej",
  "A has invite you to join the B": "A har bjudit in dig att gå med i B",
  "Switch to rich text editor": "Byt till rich text editor",
  "Add Custom Message": "Lägg till anpassat meddelande",
  "Enter message here": "Skriv meddelande här",
  "Send Bulk Mail": "Skicka massutskick",
  "Send Mail": "Skicka Mail",
  "Send bulk mail to all community members or select group members": "Skicka massutskick till alla gruppmedlemmar eller utvalda gruppmedlemmar",
  "Date": "Datum",
  "Subject": "Ämne",
  "Recipients": "Mottagare",
  "1000 bulk emails remaining for this month. Resets on <date>": "1 000 massmejl kvar denna månad. Återställs <datum>",
  "Everyone": "Alla",
  "Enter mail subject": "Ange e-postämne",
  "Write message": "Skriv meddelande",
  "Cancel__1": "Avboka",
  "Send": "Skicka",
  "__1": "#VALUE!",
  "Activity": "Aktivitet",
  "Bookmarks": "Bokmärken",
  "Edit Profile": "Redigera profil",
  "Unsubscribe": "Avsluta prenumeration",
  "Settings (Account)": "Inställningar (konto)",
  "Profile": "Profil",
  "Set Profile Picture": "Ställ in profilbild",
  "Your name": "Ditt namn",
  "User ID": "Användar-ID",
  "Short bio": "Kort biografi",
  "Link your social account": "Länka ditt sociala konto",
  "This will be displayed on your profile": "Detta kommer att visas på din profil",
  "Add social handle": "Lägg till socialt handtag",
  "Verification": "Kontroll",
  "Account Verification": "Kontoverifiering",
  "Email": "E-post",
  "Enter email": "Ange e-post",
  "Verified": "Verifierad",
  "Unverified": "Ej verifierad",
  "Change": "Ändra",
  "Unlink": "Ta bort länken",
  "Mobile": "Mobil",
  "enter mobile no.": "ange mobilnr.",
  "Request OTP": "Begär OTP",
  "Manage your personal account notification preferences": "Hantera dina personliga kontoaviseringsinställningar",
  "Prefrences": "Preferenser",
  "Email notification": "E-postmeddelande",
  "Notify me about comments on my posts": "Meddela mig om kommentarer på mina inlägg",
  "Notify me about replies on my comments": "Meddela mig om svar på mina kommentarer",
  "Notify me about upvotes on my posts": "Meddela mig om uppröster på mina inlägg",
  "Notify me about reaction on my comments": "Meddela mig om reaktion på mina kommentarer",
  "Notify me about reaction on my reply": "Meddela mig om reaktion på mitt svar",
  "Notify me about direct message": "Meddela mig om direktmeddelande",
  "Notify me about my mentions": "Meddela mig om mina omnämnanden",
  "Notification for new posts": "Avisering om nya inlägg",
  "Only group & section available which you are part of": "Endast tillgänglig grupp och sektion som du är en del av",
  "Group & Section": "Grupp & Sektion",
  "All activity": "All aktivitet",
  "Post by admin": "Inlägg av admin",
  "No Notification": "Ingen anmälan",
  "Setting (Community)": "Inställning (Community)",
  "General Settings": "Allmänna inställningar",
  "Upload community logo": "Ladda upp communitylogotypen",
  "Community name": "Gemenskapens namn",
  "Invalid field": "Ogiltigt fält",
  "Your community address": "Din gemenskapsadress",
  "Fav icon": "Favoritikon",
  "This will be visible on the browser tab (32px by 32px)": "Detta kommer att synas på webbläsarfliken (32px x 32px)",
  "TimeZone": "Tidszon",
  "Privacy Policy on login page": "Sekretesspolicy på inloggningssidan",
  "Terms & Condition on login page": "Regler och villkor på inloggningssidan",
  "Enter link here": "Ange länk här",
  "Open Group Image": "Öppna gruppbild",
  "By default ir takes up the community banner uploaded with the communtiy": "Som standard tar ir upp communitybannern som laddats upp med communityn",
  "Community Experience": "Samhällserfarenhet",
  "Onboarding": "Onboarding",
  "Make your community private": "Gör din grupp privat",
  "Users will have to login or sign up to access the community": "Användare måste logga in eller registrera sig för att få tillgång till communityn",
  "Make account verification mandatory for both email & mobile": "Gör kontoverifiering obligatorisk för både e-post och mobil",
  "New user will have to verify both email & mobile no. to access the community": "Ny användare måste verifiera både e-post och mobilnummer. för att komma åt gemenskapen",
  "Admin will also have to verify their mobile no. & email or else they won't be able to access the community": "Admin måste också verifiera sitt mobilnummer. & e-posta annars kommer de inte att kunna komma åt gruppen",
  "Gated community access": "Gated community access",
  "Admin will have to approve or reject user's requests to join the community": "Administratören måste godkänna eller avvisa användarens begäran om att gå med i gruppen",
  "Disable mobile login/register": "Inaktivera mobilinloggning/registrering",
  "Disable email login/register": "Inaktivera e-postinloggning/registrering",
  "Disable google login/register": "Inaktivera google login/register",
  "Disable facebook login/register": "Inaktivera Facebook-inloggning/registrering",
  "Show & Hide features": "Visa och dölj funktioner",
  "Hide direct chat": "Dölj direktchatt",
  "User will not be able to send direct messages to each other": "Användare kommer inte att kunna skicka direktmeddelanden till varandra",
  "Hide profile picture from top right corner for mobile responsive view": "Dölj profilbild från det övre högra hörnet för mobil responsiv vy",
  "Useful when using community in an in app browser": "Användbart när du använder community i en webbläsare i appen",
  "Hide profile picture from top right corner in every view": "Dölj profilbild från det övre högra hörnet i varje vy",
  "Disable header dropdown on profile picture": "Inaktivera rullgardinsmenyn för rubriker på profilbilden",
  "Useful for integrated community, especially using SSO": "Användbar för integrerad gemenskap, särskilt med SSO",
  "Hide the communtiy logo from the header": "Dölj gemenskapslogotypen från rubriken",
  "Hide the communtiy title from the header": "Dölj gemenskapstiteln från rubriken",
  "Show collpased group in the side nav bar": "Visa komprimerad grupp i navigeringsfältet på sidan",
  "Show full expanded post in the home feed": "Visa hela utökat inlägg i hemflödet",
  "Hide the leaderboard score from the header": "Dölj resultattavlan från sidhuvudet",
  "Show powered by Pensil": "Visa drivs av Pensil",
  "Hide closed groups if not joined": "Dölj stängda grupper om de inte går med",
  "Closed groups would not be shown to the user if they are not a member of the group": "Slutna grupper skulle inte visas för användaren om de inte är medlem i gruppen",
  "Hide Community subscriber count from the users": "Dölj antalet prenumeranter för användarna",
  "This will hide the community subscriber list in the community header": "Detta kommer att dölja listan över gemenskapsabonnenter i gemenskapshuvudet",
  "Disable Communtiy Switcher": "Inaktivera Community Switcher",
  "Use MD editor for create post description": "Använd MD editor för att skapa inläggsbeskrivning",
  "Non logged in user will land on explore group page instead of post directory": "Oinloggad användare kommer att landa på utforska gruppsidan istället för inläggskatalogen",
  "Advanced configurable": "Avancerat konfigurerbar",
  "Communtiy default country code": "Gemenskapens standard landskod",
  "This will show up by default on login/signup": "Detta visas som standard vid inloggning/registrering",
  "Onboarding/Welcome Message": "Onboarding/Välkomstmeddelande",
  "Welcome Message": "Välkomstmeddelande",
  "Greet your members with personalized message": "Hälsa dina medlemmar med personligt meddelande",
  "Welcome to": "Välkommen till",
  "Message": "Meddelande",
  "Add message": "Lägg till meddelande",
  "Custom domain": "Anpassad domän",
  "Add custom domain": "Lägg till anpassad domän",
  "Create new request": "Skapa ny förfrågan",
  "Enter your custom domain": "Ange din anpassade domän",
  "Setup details": "Inställningsdetaljer",
  "Add a CNAME record in your domain pointing to this community's address": "Lägg till en CNAME-post i din domän som pekar på den här gruppens adress",
  "To configure your domain, you'll need to add a CNAME record pointing your domain to your pensil community URL": "För att konfigurera din domän måste du lägga till en CNAME-post som pekar din domän till din pensil-gemenskapsadress",
  "Step by Step help apge": "Steg för steg hjälpsida",
  "All request list": "Lista över alla förfrågningar",
  "Allow admin to assign/un-assign custom points to users": "Tillåt administratören att tilldela/avaktivera anpassade poäng till användare",
  "Base points for user to begin with": "Baspoäng för användaren till att börja med",
  "Base points will be updated for all the users, any changes will reflect for all the users.": "Baspunkter kommer att uppdateras för alla användare, eventuella ändringar kommer att återspeglas för alla användare.",
  "Allocate points for interaction": "Tilldela poäng för interaktion",
  "Upvoting post": "Röstar upp inlägg",
  "creating a comment": "skapa en kommentar",
  "creating a reply": "skapa ett svar",
  "Getting upvote to their post": "Får rösta upp deras inlägg",
  "Getting comment to their post": "Får kommentar till deras inlägg",
  "Getting reply to their comment": "Får svar på deras kommentar",
  "Creating a post": "Skapar ett inlägg",
  "Visiblity": "Synlighet",
  "Move Up": "Flytta upp",
  "Move Down": "Flytta ner",
  "Create embedded section": "Skapa inbäddad sektion",
  "Preview area": "Förhandsgranskningsområde",
  "Theme selector": "Temaväljare",
  "Community Theme": "Gemenskapstema",
  "Select theme": "Välj tema",
  "Select brand color": "Välj märkesfärg",
  "Customize your button color to match your brand": "Anpassa din knappfärg för att matcha ditt varumärke",
  "Select on button text color": "Välj textfärg på knappen",
  "Suggestion: Keep inverted contrast against brand color": "Förslag: Håll inverterad kontrast mot märkesfärg",
  "Billing": "Fakturering",
  "Current plan": "Nuvarande plan",
  "You are current on Free PLan": "Du är aktuell med gratis PLan",
  "Renew on: NA": "Förnya den: NA",
  "Select": "Välja",
  "Email us at": "Maila oss på",
  "Compare plan": "Jämför plan",
  "API Keys": "API-nycklar",
  "Create new key": "Skapa ny nyckel",
  "Total keys": "Totalt nycklar",
  "Keep your API keys safe! You can use them to access specific feature & let cetain apps perfrom certain actions on your behalf on the platform.": "Håll dina API-nycklar säkra! Du kan använda dem för att komma åt specifika funktioner och låta vissa appar utföra vissa åtgärder för din räkning på plattformen.",
  "Key name": "Nyckelnamn",
  "Key value": "Nyckelvärde",
  "Action": "Handling",
  "Group updated!": "Gruppen uppdaterad!",
  "Are you sure you want to": "Är du säker på att du vill",
  "Make Moderator": "Gör Moderator",
  "Remove from group": "Ta bort från gruppen",
  "Show All": "Visa alla",
  "Change Role": "Byt roll",
  "Close": "Nära",
  "copy": "kopiera",
  "LINKS": "LÄNKAR",
  "Email Id": "E-post-ID",
  "Name": "Namn",
  "Search for an image": "Sök efter en bild",
  "Crop Image": "Beskär bild",
  "No photos found": "Inga foton hittades",
  "Community": "Gemenskap",
  "Banner ratio - 16:9": "Bannerförhållande - 16:9",
  "Banner Ratio - 16:6": "Bannerförhållande - 16:6",
  "Share on mail": "Dela på mail",
  "Share on Telegram": "Dela på Telegram",
  "Share on Whatsapp": "Dela på Whatsapp",
  "Share on Linkedin": "Dela på Linkedin",
  "Share on Facebook": "Dela på Facebook",
  "Share on Twitter": "Dela på Twitter",
  "Pin Post": "Pin Post",
  "Heading (optional)": "Rubrik (valfritt)",
  "Select section": "Välj avsnitt",
  "Gif": "Gif",
  "Create Custom Widget": "Skapa anpassad widget",
  "Are you sure you want to delete this widget?": "Är du säker på att du vill ta bort den här widgeten?",
  "Go to event": "Gå till evenemanget",
  "Add Tags": "Lägg till taggar",
  "Create Tag": "Skapa tagg",
  "Title (Optional)": "Titel (valfritt)",
  "Search Gif": "Sök Gif",
  "What's on your mind": "Vad tänker du på",
  "Looks like nothing available here right now.": "Det verkar som om inget är tillgängligt här just nu.",
  "Try exploring other tabs": "Testa att utforska andra flikar",
  "Delete Widget": "Ta bort widget",
  "Please select a section to post": "Välj ett avsnitt att lägga upp",
  "Post added successfully!": "Inlägget har lagts till!",
  "Failed to create post. Please check post content and retry again.": "Det gick inte att skapa inlägget. Kontrollera inläggets innehåll och försök igen.",
  "Are you sure you want to discard current post?": "Är du säker på att du vill ta bort det aktuella inlägget?",
  "By default it will take up the image uploaded with the post": "Som standard tar den upp bilden som laddats upp med inlägget",
  "Quiz can be only viewed and attempted from mobile device right now!": "Quiz kan bara ses och testas från mobil enhet just nu!",
  "Community Banner": "Gemenskapsbanner",
  "Change Cover": "Byt omslag",
  "Suggestions: Welcome to my community etc": "Förslag: Välkommen till min community osv",
  "(edited)": "(redigerad)",
  "Aspect ratio (recommended)": "Bildförhållande (rekommenderas)",
  "Banner details updated!": "Bannerinformation uppdaterad!",
  "Refresh if changes are not visible!": "Uppdatera om ändringar inte är synliga!",
  "Banner details could not be updated!": "Bannerinformation kunde inte uppdateras!",
  "Post deleted": "Inlägget raderat",
  "Post not available. It may have been deleted.": "Posten är inte tillgänglig. Det kan ha tagits bort.",
  "Admin": "Administration",
  "Moderator": "Moderator",
  "Bookmark added!": "Bokmärke har lagts till!",
  "Bookmark removed": "Bokmärket har tagits bort",
  "Failed performing action!": "Det gick inte att utföra åtgärden!",
  "Copy this link to share on other platforms": "Kopiera denna länk för att dela på andra plattformar",
  "View this event": "Se denna händelse",
  "Event": "Händelse",
  "Join Meeting": "Gå med i mötet",
  "The live meeting has ended": "Livemötet har avslutats",
  "read more...": "läs mer...",
  "Load more comments": "Ladda fler kommentarer",
  "Post Reply": "Skicka svar",
  "Post Comment": "Posta kommentar",
  "more": "mer",
  "upvoted": "uppröstade",
  "1 Upvote": "1 Rösta upp",
  "1 Comment": "1 kommentar",
  "Please enter a title": "Vänligen ange en titel",
  "Please enter a url link": "Ange en URL-länk",
  "Please enter button title": "Vänligen ange knappens titel",
  "Button label must be at least 20 characters": "Knappetikett måste bestå av minst 20 tecken",
  "Please enter valid url": "Vänligen ange en giltig webbadress",
  "Suggestions: Know more, Join, Apply...": "Förslag: Lär dig mer, gå med, ansök...",
  "URL": "URL",
  "Community Events": "Gemenskapsevenemang",
  "Widget deleted successfully": "Widget har tagits bort",
  "Community Top Contributors": "Gruppens bästa bidragsgivare",
  "points": "poäng",
  "Points cannot be greater than current points": "Poäng kan inte vara större än nuvarande poäng",
  "Point cannot be a negative value": "Punkt kan inte vara ett negativt värde",
  "Point cannot be a decimal point": "Punkt kan inte vara en decimalkomma",
  "Please enter a valid number": "Vänligen ange ett giltigt nummer",
  "Karma points updated successfully": "Karma-punkter har uppdaterats",
  "Error in updating karma points": "Fel vid uppdatering av karmapunkter",
  "Add karma points": "Lägg till karmapoäng",
  "Minus karma points": "Minus karmapoäng",
  "Total Karma points:": "Totalt antal karmapoäng:",
  "Enter no. of karma points": "Ange nr. av karmapunkter",
  "Minus Points": "Minuspoäng",
  "Trending Post": "Trendigt inlägg",
  "No visible description": "Ingen synlig beskrivning",
  "Picture ratio: 1:1": "Bildförhållande: 1:1",
  "home feed": "hemmatning",
  "Event name is invalid!": "Händelsenamnet är ogiltigt!",
  "custom": "beställnings-",
  "Custom widget updated successfully": "Anpassad widget har uppdaterats",
  "Name invalid!": "Namnet är ogiltigt!",
  "Current timezone:": "Aktuell tidszon:",
  "can be updated from community settings": "kan uppdateras från communityinställningar",
  "Event created successfully": "Händelsen har skapats",
  "Error in creating event": "Fel vid skapande av händelse",
  "Attendees": "Deltagare",
  "Do you wish to notify these changes to attendees?": "Vill du meddela dessa ändringar till deltagarna?",
  "users wants to attend this event": "användare vill delta i detta evenemang",
  "Yes, Notify them": "Ja, meddela dem",
  "No, its okay": "Nej, det är okej",
  "Do you wish to notify that event is cancelled?": "Vill du meddela att evenemanget är inställt?",
  "Are you sure you want to delete the event?": "Är du säker på att du vill ta bort händelsen?",
  "Delete Event": "Ta bort händelse",
  "New Event": "Ny händelse",
  "Accept Invitation": "Acceptera inbjudan",
  "Requested": "Begärde",
  "Declined": "Avböjde",
  "Request Access": "Begär åtkomst",
  "Enroll for": "Anmäl dig till",
  "Housefull": "Husfull",
  "Just copy paste this code wherever you want it to be embedded:": "Bara kopiera och klistra in den här koden där du vill att den ska bäddas in:",
  "Ended": "Avslutade",
  "Error getting events": "Det gick inte att hämta händelser",
  "Events could not be fetched!": "Händelser kunde inte hämtas!",
  "Show Attendees": "Visa deltagare",
  "Subscribers": "Prenumeranter",
  "Make this a closed section": "Gör detta till ett slutet avsnitt",
  "Update Section": "Uppdatera avsnitt",
  "Valid section name required!": "Giltigt avsnittsnamn krävs!",
  "Enter section name": "Ange avsnittsnamn",
  "Community Admin": "Gemenskapsadministratör",
  "Embed": "Bädda in",
  "Invite to": "Bjud in till",
  "Please enter a valid email address": "Vänligen ange en giltig e-postadress",
  "Invitation sent successfully": "Inbjudan har skickats",
  "Error sending invitation": "Det gick inte att skicka inbjudan",
  "Email is not valid!": "E-post är inte giltigt!",
  "Data could not be loaded!": "Data kunde inte laddas!",
  "Posted in": "Postat i",
  "Invite Members Individually": "Bjud in medlemmar individuellt",
  "Start a discussion": "Starta en diskussion",
  "Post something": "Lägg upp något",
  "Invite your audience": "Bjud in din publik",
  "Choose Plan": "Välj Plan",
  "or": "eller",
  "Create a link": "Skapa en länk",
  "Add link": "Lägg till länk",
  "Update link": "Uppdatera länk",
  "Add shortcut to your most used tools": "Lägg till genväg till dina mest använda verktyg",
  "Your website, Instagram Channel, Facebook profile etc": "Din hemsida, Instagramkanal, Facebook-profil etc",
  "Valid link name required!": "Giltigt länknamn krävs!",
  "Valid url required, and make sure you are not missing http:// or https://": "Giltig url krävs och se till att du inte saknar http:// eller https://",
  "Invite to__1": "Bjud in till",
  "Link Name": "Länknamn",
  "Link URL": "Länk-URL",
  "Could not subscribe to": "Det gick inte att prenumerera på",
  "Subscribed to": "Prenumererar på",
  "By default it will take up the community banner uploaded with the community": "Som standard tar den upp communitybannern som laddats upp med communityn",
  "Created by": "Skapad av",
  "Online Event (Meeting link will be visible once registered for the event)": "Onlineevenemang (möteslänk kommer att vara synlig när du har registrerat dig för evenemanget)",
  "Join Call": "Gå med i Call",
  "Please login to book this event": "Vänligen logga in för att boka detta evenemang",
  "Commented on": "kommenterade",
  "Replied to": "Svarade på",
  "Looks like it's lonely here.": "Det verkar vara ensamt här.",
  "Try exploring other sections and groups.": "Testa att utforska andra avsnitt och grupper.",
  "Please proceed with the payment or contact admin to gain access to this group.": "Fortsätt med betalningen eller kontakta administratören för att få tillgång till den här gruppen.",
  "This is a closed group You'll need access to this group.": "Detta är en sluten grupp Du behöver tillgång till den här gruppen.",
  "You have no bookmarks right now.": "Du har inga bokmärken just nu.",
  "The user hasn't posted anything yet publicly.": "Användaren har ännu inte lagt upp något offentligt.",
  "No activity to show.": "Ingen aktivitet att visa.",
  "Are you sure you want to unsubscribe the community?": "Är du säker på att du vill avsluta prenumerationen på gruppen?",
  "deals left": "erbjudanden kvar",
  "Something went wrong while loading posts": "Något gick fel när inlägg laddades",
  "Could not unsubscribe from": "Det gick inte att avsluta prenumerationen från",
  "Unsubscribed from": "Avslutad prenumeration från",
  "Login to view this page": "Logga in för att se denna sida",
  "Login": "Inloggning",
  "There was some error while doing the action!": "Det uppstod ett fel när åtgärden utfördes!",
  "Unable to delete section!": "Det gick inte att ta bort avsnitt!",
  "__2": "",
  "__3": "",
  "__4": "",
  "Home page": "Hemsida",
  "Members Directory": "Medlemsregister",
  "Calendar": "Kalender",
  "Create Group": "Skapa grupp",
  "Start Live Session": "Starta livesession",
  "Home__1": "Hem",
  "Following": "Följande",
  "__5": "",
  "Post Card": "Vykort",
  "Like": "Som",
  "Comment__1": "Kommentar",
  "Comment__2": "Kommentar",
  "Share__1": "Dela",
  "Report": "Rapportera",
  "Follow User": "Följ användare",
  "Report User": "Rapportera användare",
  "Report Post": "Anmäl inlägg",
  "__6": "",
  "LeaderBoard Floating pop up": "Leaderboard Flytande popup",
  "Go to leaderboard": "Gå till topplistan",
  "Total karma points": "Totala karmapoäng",
  "Comments__1": "Kommentarer",
  "Upvotes__1": "Uppröster",
  "Replies__1": "Svar",
  "Post__1": "Posta",
  "Custom Points__1": "Anpassade poäng",
  "Base Points": "Baspunkter",
  "__7": "",
  "Channel": "Kanal",
  "This is a private channel": "Det här är en privat kanal",
  "You'll need access to this channel": "Du behöver åtkomst till den här kanalen",
  "__8": "",
  "Profile Page": "Profilsida",
  "Followers": "Följare",
  "Activities": "Aktiviteter",
  "__9": "",
  "Settings Page": "Inställningssida",
  "Go back to community": "Gå tillbaka till samhället",
  "Account": "Konto",
  "Notification Centre": "Aviseringscenter",
  "__10": "",
  "Edit Profile Page": "Redigera profilsida",
  "Set profile Picture": "Ställ in profilbild",
  "Your name__1": "Ditt namn",
  "Subtitle": "Texta",
  "(Max char 60)": "(Max röding 60)",
  "User Id": "Användar-ID",
  "Short Bio": "Kort biografi",
  "Link For Social Account": "Länk för socialt konto",
  "This will be displayed on your profile__1": "Detta kommer att visas på din profil",
  "Add Social handles": "Lägg till sociala handtag",
  "__11": "",
  "Verification Page": "Verifieringssida",
  "Email__1": "E-post",
  "Verified__1": "Verifierad",
  "__12": "",
  "Manage your personal account notification preferences__1": "Hantera dina personliga kontoaviseringsinställningar",
  "Preferences": "Inställningar",
  "Email Notification": "E-postmeddelande",
  "Notify me about comment on my posts": "Meddela mig om kommentarer på mina inlägg",
  "Notify me about replies on my comment": "Meddela mig om svar på min kommentar",
  "Notify me about upvote on my post": "Meddela mig om uppröstning på mitt inlägg",
  "Notify me about reaction to my comment": "Meddela mig om reaktion på min kommentar",
  "Notify me about reaction on my reply__1": "Meddela mig om reaktion på mitt svar",
  "Notify me about direct message__1": "Meddela mig om direktmeddelande",
  "Notify me about mentions": "Meddela mig om omnämnanden",
  "Notification for new posts__1": "Avisering om nya inlägg",
  "Only groups and channel available which you are part of. You can also control notification": "Endast grupper och kanal tillgängliga som du är en del av. Du kan också styra aviseringar",
  "Group & Channels": "Grupp & kanaler",
  "All Activity": "All aktivitet",
  "Post by admin__1": "Inlägg av admin",
  "No Notification__1": "Ingen anmälan",
  "__13": "",
  "Direct Message__1": "Direktmeddelande",
  "Inbox": "Inkorg",
  "No chats found": "Inga chattar hittades",
  "__14": "",
  "Create Post Popup": "Skapa inläggspopup",
  "Create Post in": "Skapa inlägg i",
  "Select Channel": "Välj Kanal",
  "__15": "",
  "Dark Mode": "Mörkt läge",
  "__16": "",
  "has created a post in": "har skapat ett inlägg i",
  "joined": "gick med",
  "wants to join__1": "vill vara med",
  "liked your post!": "gillade ditt inlägg!",
  "has commented on your post in": "har kommenterat ditt inlägg i",
  "has replied to your comment on a post in": "har svarat på din kommentar på ett inlägg i",
  "has mentioned you in a post in": "har nämnt dig i ett inlägg i",
  "has mentioned you in a comment": "har nämnt dig i en kommentar",
  "has mentioned you in a reply": "har nämnt dig i ett svar"
}